// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"f1f0a671","850":"b7ac5fc4"}[chunkId] + ".chunk.css";
};